import './GaliDesawar.css';

function GaliDesawar({ onBack }) {
  const markets = [
    {
      name: 'DISAWAR',
      openTime: '12 00 AM',
      closeTime: '03 30 AM',
      status: 'Market Running',
      rating: 2
    },
    {
      name: 'FARIDABAD',
      openTime: '12 00 AM',
      closeTime: '05 40 PM',
      status: 'Market Running',
      rating: 2
    },
    {
      name: 'GHAZIABAD',
      openTime: '12 00 AM',
      closeTime: '09 15 PM',
      status: 'Market Running',
      rating: 2
    },
    {
      name: 'GALI',
      openTime: '12 00 AM',
      closeTime: '11 30 PM',
      status: 'Market Running',
      rating: 2
    }
  ];

  return (
    <div className="gali-desawar-page">
      {/* Header with Back Button */}
      <header className="gali-header">
        <button className="back-btn" onClick={onBack}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <h1>Gali Desawar</h1>
        <div style={{width: '24px'}}></div>
      </header>

      {/* Game Rates Card */}
      <div className="game-rates-card">
        <h2 className="rates-title">Gali Desawar</h2>
        <div className="rate-row">
          <span className="rate-label">Left Digit</span>
          <span className="rate-value">10-98</span>
        </div>
        <div className="rate-row">
          <span className="rate-label">Right Digit</span>
          <span className="rate-value">10-98</span>
        </div>
        <div className="rate-row">
          <span className="rate-label">Jodi Digit</span>
          <span className="rate-value">10-1000</span>
        </div>
      </div>

      {/* History Buttons */}
      <div className="history-buttons">
        <button className="history-btn bid-history-btn">
          Bid History
        </button>
        <button className="history-btn winning-history-btn">
          Winning History
        </button>
      </div>

      {/* Market Cards */}
      <div className="markets-container">
        {markets.map((market, index) => (
          <div key={index} className="market-card">
            <div className="market-header-section">
              <div>
                <h3 className="market-name">{market.name}</h3>
                <div className="market-rating">
                  {[...Array(market.rating)].map((_, i) => (
                    <span key={i} className="star">★</span>
                  ))}
                </div>
              </div>
              <div className="market-status-section">
                <span className="market-status">{market.status}</span>
                <button className="play-now-btn">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <circle cx="24" cy="24" r="24" fill="#22c55e"/>
                    <path d="M19 14L33 24L19 34V14Z" fill="white"/>
                  </svg>
                </button>
                <span className="play-now-text">Play Now</span>
              </div>
            </div>
            <div className="market-timing">
              <div className="timing-col">
                <span className="timing-label">Open Bids:</span>
                <span className="timing-value">{market.openTime}</span>
              </div>
              <div className="timing-col">
                <span className="timing-label">Close Bids:</span>
                <span className="timing-value">{market.closeTime}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default GaliDesawar;
